/**
 * min/max範囲に押さえつける
 *
 * @param {integer} min 最小値
 * @param {integer} max 最大値
 * @returns
 */
Number.prototype.clamp = function (min, max) {
  return Math.min(Math.max(this, min), max)
}

/**
 * 少数第n位の扱い
 *
 * @param {integer} digit 少数第n位
 * @returns
 */
Number.prototype.fixed = function (digit = 0) {
  return parseFloat((this + 1 / Math.pow(10, digit)).toFixed(digit))
}

/**
 * 指定された描画コンテキストに描画処理を行う
 *
 * @param {CanvasRenderingContext2D} ctx 描画コンテキスト
 * @param {function} fn 描画処理を行う関数
 */
export function drawPath(ctx, fn) {
  ctx.save()
  ctx.beginPath()
  fn()
  ctx.closePath()
  ctx.restore()
}

/**
 * イージング関数
 *
 * @param {integer} t 現在の時間
 * @param {integer} b 開始値 (始点)
 * @param {integer} c 変化量 (終了値 - 開始値)
 * @param {integer} d 総時間
 * @returns
 */
export function easeInQuart(t, b, c, d) {
  return c * (t /= d) * t * t * t + b
}

/**
 * イージング関数
 *
 * @param {integer} x 現在の時間
 * @returns
 */
export function easeInCubic(x) {
  return x * x * x
}

/**
 * イージング関数
 *
 * @param {integer} x 現在の時間
 * @returns
 */
export function easeOutCubic(x) {
  return 1 - Math.pow(1 - x, 3)
}

/**
 * イージング関数
 *
 * @param {integer} t 現在の時間
 * @param {integer} b 開始値 (始点)
 * @param {integer} c 変化量 (終了値 - 開始値)
 * @param {integer} d 総時間
 * @returns
 */
export function easeQuinticOut(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b
}

/**
 * イージング関数
 *
 * @param {integer} start 開始値
 * @param {integer} end 終了値
 * @param {integer} multiplier 割合
 * @param {integer} fixed 少数第n位の扱い
 * @returns
 */
export function lerp(start, end, multiplier, fixed = 5) {
  return ((1 - multiplier) * start.fixed(fixed) + multiplier * end.fixed(fixed)).fixed(fixed)
}

/**
 * 指定された値の範囲のランダム値を返す
 *
 * @param {integer} min 最小値
 * @param {integer} max 最大値
 * @param {boolean} int trueの場合は整数を返す
 * @returns ランダム値
 */
export function random(min, max, int) {
  let result = min + Math.random() * (max + (int ? 1 : 0) - min)
  return int ? parseInt(result) : result
}

/**
 * 時間経過によるゆらぎ位置を取得
 *
 * @param {integer} time 経過時間
 * @param {integer} x 現在のx座標
 * @param {integer} y 現在のy座標
 * @param {integer} z 現在のz座標
 * @returns
 */
export function getBlurPosition(time, x, y, z) {
  const m = Math.max(Math.abs(x), Math.abs(y))
  return {
    x: x + Math.cos(time * m * 0.001) * (0.01 + Math.sin(y) * 0.01),
    y: y + Math.sin(time * m * 0.001) * (0.01 + Math.cos(x) * 0.01),
    z: z,
  }
}

/**
 * 二つの値の割合値を取得
 *
 * @param {integer} before 開始値
 * @param {integer} after 終了値
 * @param {integer} ratio 割合
 * @returns
 */
export function getMixValue(before, after, ratio) {
  return before * (1 - ratio) + after * ratio
}

/**
 * 二つの座標の割合値を取得
 *
 * @param {integer} before 開始座標(hex)
 * @param {integer} after 終了座標(hex)
 * @param {integer} ratio 割合
 * @returns
 */
export function getMixPosition(before, after, ratio) {
  const x = getMixValue(before.x, after.x, ratio)
  const y = getMixValue(before.y, after.y, ratio)
  const z = getMixValue(before.z, after.z, ratio)
  return [x, y, z]
}

/**
 * 対象要素のサイズ・位置情報を取得
 *
 * @param {Element | string} target 対象の要素、または名前
 * @returns
 */
export function getRect(target) {
  const elm = target instanceof Element ? target : document.querySelector(target)
  const rect = elm.getBoundingClientRect()

  rect.offsetTop = rect.top + document.documentElement.scrollTop
  rect.offsetLeft = rect.left + document.documentElement.scrollLeft

  return rect
}

/**
 * 二点の距離を取得
 *
 * @param {integer} p1 開始値
 * @param {integer} p2 終了値
 * @returns
 */
export function getVectorLength(p1, p2) {
  return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2))
}

export const tools = {}
